import { StyleSheet, Text, View } from "@react-pdf/renderer";
import { Product } from "../../Store/interfaces";

const ProductTableFP: React.FC<{ products: Product[] }> = ({ products }) => {
  const styles = StyleSheet.create({
    page: {
      padding: 30,
      fontFamily: "Helvetica",
    },
    table: {
      display: "flex",
      width: "100%",
      borderStyle: "solid",
      borderWidth: 1,
      marginBottom: 20,
    },
    tableRow: {
      flexDirection: "row",
    },
    tableCell: {
      height: "25px",
      borderStyle: "solid",
    },
    tableCellHead: {
      borderStyle: "solid",
    },
    cellText: {
      padding: 5, // Add padding to the text for spacing
    },
  });

  // let summe: number = 0;

  // products.forEach((product) => {
  //   summe += product.vk * product.menge;
  // });

  return (
    <View style={styles.table}>
      {/* Table Header */}
      <View style={styles.tableRow}>
        <View style={[styles.tableCellHead, { width: "8%" }]}>
          <Text style={styles.cellText}>Pos</Text>
        </View>
        <View style={[styles.tableCellHead, { width: "84%" }]}>
          <Text style={styles.cellText}>Produkt</Text>
        </View>
        <View style={[styles.tableCellHead, { width: "8%" }]}>
          <Text style={styles.cellText}>Menge</Text>
        </View>
        {/* <View style={[styles.tableCellHead, { width: "10%" }]}>
          <Text style={styles.cellText}>Preis</Text>
        </View>
        <View style={[styles.tableCellHead, { width: "12%" }]}>
          <Text style={styles.cellText}>Summe</Text>
        </View> */}
      </View>

      {/* Table Rows */}
      {products.map((product: Product, index: number) => (
        <View key={product.id} style={styles.tableRow}>
          <View style={[styles.tableCell, { width: "8%" }]}>
            <Text style={styles.cellText}>{index + 1}</Text>
          </View>
          <View style={[styles.tableCell, { width: "84%" }]}>
            <Text style={styles.cellText}>{product.artikel}</Text>
          </View>
          <View
            style={[
              styles.tableCell,
              { textAlign: "right", width: "8%", marginLeft: "5" },
            ]}
          >
            <Text style={styles.cellText}>{product.menge}</Text>
          </View>
          {/* <View style={[styles.tableCell, { width: "10%" }]}>
            <Text style={styles.cellText}>{product.vk.toFixed(2)} €</Text>
          </View>
          <View style={[styles.tableCell, { width: "12%" }]}>
            <Text style={styles.cellText}>
              {(product.vk * product.menge).toFixed(2)} €
            </Text>
          </View> */}
        </View>
      ))}
      {/* <View style={{ borderTop: 1 }}> */}
      {/* <View style={styles.tableRow}>
        <View style={[styles.tableCell, { width: "4%" }]}>
          <Text></Text>
        </View>
        <View style={[styles.tableCell, { width: "65%" }]}>
          <Text>Summe: </Text>
        </View>
        <View style={[styles.tableCell, { width: "8%", borderTop: 1 }]}>
          <Text></Text>
        </View>
        <View style={[styles.tableCell, { width: "10%", borderTop: 1 }]}>
          <Text></Text>
        </View>
        <View style={[styles.tableCell, { width: "12%", borderTop: 1 }]}>
          <Text style={styles.cellText}>{summe.toFixed(2)} €</Text>
        </View>*/}
      {/* </View> */}
      {/* </View> */}
    </View>
  );
};

export default ProductTableFP;
